import React, { useEffect, useState } from "react";
import {
  IoCheckbox,
  IoChevronBackOutline,
  IoSquareOutline,
} from "react-icons/io5";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import {
  Dropdown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import styles from "./Signup.module.css";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import {
  validateEmail,
  validateForm,
  validatePassword,
} from "../../../utills/Validators";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [signupCheck, setSignupCheck] = useState(true);
  const [is_customer, setIs_customer] = useState(false);
  const [role, setRole] = useState({
    value: "Dealership",
    id: 1,
  });

  const formStateDealership = [
    // { key: "First Name", value: firstName },
    // { key: "Last Name", value: lastName },
    { key: "Name", value: lastName },
    { key: "Email", value: email },
    { key: "Contact number", value: contactNo },
    { key: "Address", value: address },
    { key: "Password", value: password },
    { key: "Confirm Password", value: confirmPass },
    {
      message: "Agree terms & conditions and privacy policy check.",
      value: signupCheck,
    },
  ];

  const formStateCustomer = [
    { key: "First Name", value: firstName },
    { key: "Last Name", value: lastName },
    { key: "Email", value: email },
    { key: "Contact number", value: contactNo },
    { key: "Address", value: address },
    { key: "Password", value: password },
    { key: "Confirm Password", value: confirmPass },
    {
      message: "Agree terms & conditions and privacy policy check.",
      value: signupCheck,
    },
  ];

  const onPressSignUp = () => {
    let userdata = {
      role: role.value.toLowerCase(),
      firstName,
      lastName,
      name: lastName,
      email,
      contactNo,
      address,
      password,
      confirmPass,
    };
    const validation = validateForm(
      is_customer ? formStateCustomer : formStateDealership,
    );
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else if (!validateEmail(email)) {
      dispatch(
        showAlert({
          message:
            "Please enter a valid email address in the correct format (e.g: example@example.com)",
        }),
      );
      return;
    } else if (!validatePassword(password)) {
      dispatch(
        showAlert({
          message:
            "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.",
        }),
      );
      return;
    } else if (password != confirmPass) {
      dispatch(
        showAlert({
          message: "Please make sure both passwords are identical.",
        }),
      );
      return;
    } else {
      if (is_customer) {
        delete userdata.name;
      } else {
        delete userdata.firstName;
        delete userdata.lastName;
      }

      dispatch(AuthMiddleware.signUp(userdata))
        .then(() =>
          navigate("/verifyCode", {
            state: { screen: "signup", role: role?.value, email },
          }),
        )
        .catch(() => {});
    }
  };

  useEffect(() => {
    setIs_customer(role?.value === "Customer" ? true : false);
  }, [role]);

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline />
            <TextComponent text={"Back to login"} />
          </div>
          <div className={styles.textDiv}>
            <TextComponent className={styles.welcomeHeading} text={"Welcome"} />
            <TextComponent
              className={styles.welcomeText}
              text={"Enter your credentials to create an account"}
            />
          </div>
          <div className={styles.inputDiv}>
            <Dropdown
              className={styles.input}
              label={"Role"}
              value={role}
              labelStyle={{ color: "#838383", fontSize: 18 }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Dealership",
                  id: 1,
                },
                {
                  value: "Customer",
                  id: 2,
                },
              ]}
              onChange={(e) => setRole(e)}
            />
            {is_customer ? (
              <div className={styles.twoInputsDivs}>
                <InputField
                  className={styles.twoInputs}
                  label={"First name"}
                  placeholder={"Chris"}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <InputField
                  className={styles.twoInputs}
                  label={"Last name"}
                  placeholder={"Glasser"}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            ) : (
              <InputField
                className={styles.input}
                label={"Full Name"}
                placeholder={"Chris lastname"}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            )}

            <InputField
              className={styles.input}
              label={"Email"}
              placeholder={"chris@email.com"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <PhoneInput
              label={"Contact number"}
              placeholder={"(301) 580-7410"}
              className={styles.input}
              value={contactNo}
              onChange={setContactNo}
            />

            <InputField
              className={styles.input}
              label={"Address"}
              placeholder={"4387 Farland Avenue, San Antonio, TX 78212"}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <div className={styles.twoInputsDivs}>
              <InputField
                className={styles.twoInputs}
                label={"Password"}
                placeholder={"●●●●●●●●●●"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                rightIcon={
                  passwordVisible ? (
                    <LuEye size={20} color={"var(--input-icon)"} />
                  ) : (
                    <LuEyeOff size={20} color={"var(--input-icon)"} />
                  )
                }
                onRightIconPress={() => setPasswordVisible(!passwordVisible)}
                type={passwordVisible ? "text" : "password"}
              />
              <InputField
                className={styles.twoInputs}
                label={"Confirm Password"}
                placeholder={"●●●●●●●●●●"}
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
                rightIcon={
                  confirmPassVisible ? (
                    <LuEye size={20} color={"var(--input-icon)"} />
                  ) : (
                    <LuEyeOff size={20} color={"var(--input-icon)"} />
                  )
                }
                onRightIconPress={() =>
                  setConfirmPassVisible(!confirmPassVisible)
                }
                type={confirmPassVisible ? "text" : "password"}
              />
            </div>
          </div>
          {/* <div className={styles.logoutCheck}>
            {signupCheck ? (
              <IoCheckbox
                color="var(--secondary-color)"
                style={{ cursor: "pointer" }}
                onClick={() => setSignupCheck(!signupCheck)}
              />
            ) : (
              <IoSquareOutline
                style={{ cursor: "pointer" }}
                onClick={() => setSignupCheck(!signupCheck)}
              />
            )}
            <TextComponent
              style={{ marginLeft: "5px" }}
              text={"By signing up, I agree to the "}
            >
              <text className={styles.link}>Terms and Conditions</text>
              <text> & </text>
              <text className={styles.link}>Privacy Policy.</text>
            </TextComponent>
          </div> */}
          <div className={styles.btn}>
            <SubmitButton title={"Sign up"} onClick={onPressSignUp} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
